import http from '@/http'

const PATH = '/hubspot/property-groups'

export default {
    /**
     * @param {{}} params
     * @returns {Promise<void>}
     */
    async listCompanyProperties (params) {
        try {
            const response = await http.get(`${PATH}/company`, {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
